import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=6977411a&scoped=true&"
import script from "./NewTicket.vue?vue&type=script&lang=js&"
export * from "./NewTicket.vue?vue&type=script&lang=js&"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=6977411a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977411a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6977411a')) {
      api.createRecord('6977411a', component.options)
    } else {
      api.reload('6977411a', component.options)
    }
    module.hot.accept("./NewTicket.vue?vue&type=template&id=6977411a&scoped=true&", function () {
      api.rerender('6977411a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/NewTicket.vue"
export default component.exports